import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "../../redux/actions/userActions";
import AccountPanel from "../../components/profile/AccountPanel";
import BottomBar from "../../components/bottomBar/BottomBar";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userDetails = useSelector((state) => state.userDetails);
  const { error, loading, savedUserConfig } = userDetails;

  useEffect(() => {
    // generateText(prompt);
    let accessToken = localStorage.getItem("accessToken");
    dispatch(getUserDetails({ accessToken: accessToken }));

    if (savedUserConfig?.waitlist) {
      navigate("/waitlist");
    }
  }, [savedUserConfig?._id]);

  return (
    <>
      {/* <Navbar /> */}
      <div className="w-full mx-auto bg-white">
        {/* <div className="grid place-items-center">
          <TopMenu />
        </div> */}
        <AccountPanel savedUserConfig={savedUserConfig} />
        <BottomBar />
      </div>
    </>
  );
};

export default Profile;
